import React from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FullWidthButton from "../components/buttons/FullWidthButton";

const RendelesTipus = () => {
	const { order, updateOrder} = useOrder();
	const navigate = useStepNavigate();

	const handleOptionClick = (order_type) => {

		// ha 3-asat, privátot választott, akkor ide már be kell tenni a specaidtype-ot is
		if (order_type === 3) {
			updateOrder({
				...order,
				hmeliorder: {
					...order.hmeliorder,
					hmeliorder_order_type: order_type,
					hmeliorder_specaidtype: 6,
					hmeliorder_specaidtype_national: 'Privát',
				},
			});
		} else {
			updateOrder({
				...order,
				hmeliorder: {
					...order.hmeliorder,
					hmeliorder_order_type: order_type,
				}
			});
		}

		setTimeout(() => {
			if (order_type === 3) {
				navigate("/VoltMegrendeles");
			} else {
				navigate("/Taj");
			}
		}, 10);
	};

	const handleBackClick = () => {
		navigate("/Meretlap");
	};

	return (
		<>
			<TablerLayout title="Válassza ki a rendelés típusát!">
				<div className="row justify-content-center">
					<div className="col-md-10 text-center mb-4">
						<FullWidthButton onClick={() => handleOptionClick(1)} height="100px" plusClass="fs-3">
							Vényes
						</FullWidthButton>
					</div>
					<div className="col-md-10 text-center mb-4">
						<FullWidthButton onClick={() => handleOptionClick(2)} height="100px" className="btn-elit-narancs" plusClass="fs-3">
							Telemedicina
						</FullWidthButton>
					</div>
					<div className="col-md-10 text-center mb-4">
						<FullWidthButton onClick={() => handleOptionClick(3)} height="100px" className="btn-elit-lila" plusClass="fs-3">
							Privát
						</FullWidthButton>
					</div>
				</div>
			</TablerLayout>
			<StepperNavButton side="left" label="Vissza" onClick={handleBackClick} />
		</>
	);
};

export default RendelesTipus;
